import { render, staticRenderFns } from "./add-banner-boost.vue?vue&type=template&id=b0830ee0&"
import script from "./add-banner-boost.vue?vue&type=script&lang=js&"
export * from "./add-banner-boost.vue?vue&type=script&lang=js&"
import style0 from "./add-banner-boost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports